import React, { useState } from "react";
import { useModal } from "../../../../../../contexts/modalContext/modalContext.js";
import Button from "../../../../../Elements/Button/Button.js";
import { useContent } from "../../../../../../contexts/contentContext/contentContext.js";
import ChangeUserEmailModal from "./ChangeUserEmailModal.js";

const WarningMailsModal = ({
  userData,
  newBody,
  setEmailAddress,
  userDetails,
}) => {
  const { closeModal } = useModal();
  const { getTextByKey } = useContent();

  const { setModal } = useModal();

  return (
    <div className="warning-change-usermail-modal">
      <div className="top-section">
        <div className="modal-content">
          <div className="modal-body">
            <div>
              <p>
                {getTextByKey("profileuserdetails-warning-mails")}
              </p>
            </div>
            <div className="actions">
              <Button
                buttonClass="cancel-button"
                blank
                onClick={() => {
                    closeModal();
                }}
              >
                {getTextByKey("cancel")}
              </Button>
              <Button
                buttonClass="ok-button"
                onClick={() => {
                  closeModal();
                  setModal(() => (
                      <ChangeUserEmailModal
                          userDetails={userDetails}
                          userData={userData}
                          newBody={newBody}
                          setEmailAddress={setEmailAddress}
                      />
                  ));
                }}
              >
                {getTextByKey(
                  "profileuserdetails-change-email-verification-approve"
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="bottom-section"></div>
    </div>
  );
};

export default WarningMailsModal;
